<script>
  import solicitacaoReembolsoServico from '../servico';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalProtocolos from '~componentes/ModalProtocolos.vue';
  import tipoUsuario from '~js/tipo-usuario';
  import projetoServico from '~modulos/projeto/servico';
  import DatePicker from 'vue2-datepicker';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';

  const DIAS_ALERTA_PRAZO = 15;

  const SECOES = [
    { nivel: 'rejeitada', label: 'Rejeitadas - Reenviar Prestação', filtro: 'Rejeitadas', classe: 'secao-rejeitada' },
    { nivel: 'vencida', label: 'Prazo Vencido', filtro: 'Prazo vencido', classe: 'secao-rejeitada' },
    { nivel: 'vencendo', label: `Prazo Terminando (até ${DIAS_ALERTA_PRAZO} dias)`, filtro: 'Prazo terminando', classe: 'secao-pendente' },
    { nivel: 'pendente', label: 'A Prestar Contas - No Prazo', filtro: 'No prazo', classe: 'secao-pendente-leve' },
    { nivel: 'enviada', label: 'Prestadas - Aguardando Conferência', filtro: 'Prestadas', classe: 'secao-enviada' },
    { nivel: 'aceita', label: 'Aceitas', filtro: 'Aceitas', classe: 'secao-aceita' },
  ];

  const SITUACOES = [
    { valor: 'prestar', label: 'A prestar contas', niveis: ['rejeitada', 'vencida', 'vencendo', 'pendente'] },
    { valor: 'prestadas', label: 'Prestadas - aguardando conferência', niveis: ['enviada'] },
    { valor: 'aceitas', label: 'Aceitas', niveis: ['aceita'] },
    { valor: 'todas', label: 'Todas', niveis: SECOES.map(s => s.nivel) },
  ];

  const SITUACAO_PADRAO_COORDENADOR = 'prestar';

  export default {
    name: 'SolicitacaoReembolsoPendentesLista',
    components: { ModalMensagem, ModalProtocolos, DatePicker },
    data() {
      const usuario = this.$storage.usuario();
      const coordenador = usuario.tipoUsuario === tipoUsuario.Coordenador;
      const situacao = coordenador ? SITUACAO_PADRAO_COORDENADOR : 'todas';

      return {
        situacoes: SITUACOES,
        situacao,
        filtros: { idProjeto: '0', periodo: '', documento: '' },
        projetos: [],
        solicitacoes: [],
        carregando: true,
        solicitacaoSelecionada: null,
        animated: true,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
        modalProtocolos: false,
        secoes: SECOES,
        diasAlertaPrazo: DIAS_ALERTA_PRAZO,
        niveisMarcados: SITUACOES.find(s => s.valor === situacao).niveis.slice(),
        usuario,
      }
    },
    computed: {
      pessoaFisica() {
        return this.usuario.tipoUsuario === tipoUsuario.PessoaFisica;
      },
      coordenador() {
        return this.usuario.tipoUsuario === tipoUsuario.Coordenador;
      },
      situacaoAtual() {
        return this.situacoes.find(s => s.valor === this.situacao) || this.situacoes[this.situacoes.length - 1];
      },
      mostrarPainelResumo() {
        return !this.coordenador || this.situacaoAtual.niveis.includes('pendente');
      },
      filtrosBag() {
        return {
          niveis: this.niveisMarcados.slice(),
          situacao: this.situacao,
          idProjeto: this.filtros.idProjeto,
          periodo: this.filtros.periodo,
          documento: this.filtros.documento,
        };
      },
      documentoFiltroFormatado() {
        const cpf = this.filtros.documento || '';
        if (cpf.length !== 11) {
          return cpf;
        }
        return `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, 2)}`;
      },
      usarMensageria() {
        return !this.pessoaFisica && !this.configuracao.naoUtilizarMensageria && !this.configuracao.desativarMensageriaSolReembolso;
      },
      totalColunas() {
        return 13 + (this.usarMensageria ? 1 : 0) + (this.pessoaFisica ? 0 : 1) + (this.configuracao.criarProtocoloSolicitacao ? 1 : 0);
      },
      hojeMs() {
        const hoje = new Date();
        return new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate()).getTime();
      },
      quantidadePorNivel() {
        const quantidade = {};
        for (const secao of this.secoes) {
          quantidade[secao.nivel] = 0;
        }
        for (const solicitacao of this.solicitacoes) {
          quantidade[this.nivel(solicitacao)]++;
        }
        return quantidade;
      },
      quantidadeGrave() {
        return this.quantidadePorNivel.rejeitada + this.quantidadePorNivel.vencida;
      },
      quantidadeParaPrestar() {
        return this.quantidadeGrave + this.quantidadePorNivel.vencendo + this.quantidadePorNivel.pendente;
      },
      linhasComCabecalhos() {
        const itens = [];

        for (const secao of this.secoes) {
          if (!this.niveisMarcados.includes(secao.nivel)) continue;

          const lista = this.solicitacoes.filter(s => this.nivel(s) === secao.nivel);
          if (!lista.length) continue;

          if (['rejeitada', 'vencida', 'vencendo', 'pendente'].includes(secao.nivel)) {
            lista.sort((a, b) => this.prazoMs(a) - this.prazoMs(b));
          }

          itens.push({ tipo: 'cabecalho', secao, quantidade: lista.length });
          for (const solicitacao of lista) {
            itens.push({ tipo: 'linha', solicitacao });
          }
        }

        return itens;
      },
      totalLinhas() {
        return this.linhasComCabecalhos.filter(i => i.tipo === 'linha').length;
      },
    },
    methods: {
      lista() {
        this.carregando = true;
        this.solicitacoes = [];

        const filtros = this.coordenador ? this.filtros : {};

        return solicitacaoReembolsoServico.listaPendentes(0, filtros)
          .then(res => {
            this.carregando = false;
            this.solicitacoes = res.body;
          })
          .catch(erro => {
            this.carregando = false;
            this.$mensagemErro(erro, 'Erro ao carregar a lista.');
          });
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao('SolReembolsoAtividade')
          .then(projetos => {
            this.projetos = projetos;
            this.$nextTick(() => {
              $('#projeto').val(this.filtros.idProjeto).trigger('change.select2');
            });
          });
      },
      alterarSituacao() {
        this.niveisMarcados = this.situacaoAtual.niveis.slice();
        this.lista();
      },
      alterarPeriodo(periodo) {
        this.filtros.periodo = periodo;
        this.lista();
      },
      restaurarFiltros(bag) {
        if (Array.isArray(bag)) {
          this.niveisMarcados = bag.slice();
          return;
        }

        if (!bag || typeof bag !== 'object') {
          return;
        }

        if (this.coordenador && this.situacoes.some(s => s.valor === bag.situacao)) {
          this.situacao = bag.situacao;
          this.filtros.idProjeto = bag.idProjeto || '0';
          this.filtros.periodo = bag.periodo || '';
          this.filtros.documento = bag.documento || '';
        }

        if (Array.isArray(bag.niveis)) {
          this.niveisMarcados = bag.niveis.slice();
        }
      },
      aplicarFiltroDaNotificacao(nivel) {
        const situacao = this.situacoes.find(s => s.valor === 'todas');

        if (!this.coordenador || !nivel || !situacao.niveis.includes(nivel)) {
          return;
        }

        this.situacao = situacao.valor;
        this.filtros.idProjeto = '0';
        this.filtros.periodo = '';
        this.niveisMarcados = [nivel];
      },
      aplicarFiltroDoBeneficiario(documento) {
        const cpf = String(documento || '').replace(/\D/g, '');

        if (!this.coordenador || !cpf) {
          return;
        }

        const todas = this.situacoes.find(s => s.valor === 'todas');

        this.situacao = todas.valor;
        this.niveisMarcados = todas.niveis.slice();
        this.filtros.idProjeto = '0';
        this.filtros.periodo = '';
        this.filtros.documento = cpf;
      },
      limparFiltroBeneficiario() {
        this.filtros.documento = '';

        if (this.$route.query.documento) {
          this.$router.replace({ name: this.$route.name });
          return;
        }

        this.lista();
      },
      alternarNivel(nivel) {
        const indice = this.niveisMarcados.indexOf(nivel);
        if (indice >= 0) {
          this.niveisMarcados.splice(indice, 1);
        } else {
          this.niveisMarcados.push(nivel);
        }
      },
      prazoMs(solicitacao) {
        if (!solicitacao.dataLimitePrestacao) {
          return Number.MAX_SAFE_INTEGER;
        }
        const prazo = new Date(solicitacao.dataLimitePrestacao);
        return new Date(prazo.getFullYear(), prazo.getMonth(), prazo.getDate()).getTime();
      },
      diasParaPrazo(solicitacao) {
        if (!solicitacao.dataLimitePrestacao) {
          return null;
        }
        return Math.round((this.prazoMs(solicitacao) - this.hojeMs) / 86400000);
      },
      nivel(solicitacao) {
        const situacao = this.situacaoPrestacao(solicitacao);
        if (situacao !== 'pendente') {
          return situacao;
        }

        const dias = this.diasParaPrazo(solicitacao);
        if (dias === null) {
          return 'pendente';
        }
        if (dias < 0) {
          return 'vencida';
        }
        if (dias <= DIAS_ALERTA_PRAZO) {
          return 'vencendo';
        }
        return 'pendente';
      },
      textoPrazo(solicitacao) {
        const situacao = this.situacaoPrestacao(solicitacao);
        if (situacao === 'aceita' || situacao === 'enviada') {
          return '';
        }

        const dias = this.diasParaPrazo(solicitacao);
        if (dias === null) {
          return '';
        }
        if (dias < 0) {
          return -dias === 1 ? 'venceu há 1 dia' : `venceu há ${-dias} dias`;
        }
        if (dias === 0) {
          return 'vence hoje';
        }
        return dias === 1 ? 'vence amanhã' : `faltam ${dias} dias`;
      },
      status(solicitacao) {
        if (solicitacao.liberacaoCoordenador && solicitacao.statusSolicitacao === 0) {
          return 'Liberada pelo coordenador';
        } else if (solicitacao.statusSolicitacao === 1) {
          return 'Liberada pela instituição';
        } else if (solicitacao.statusSolicitacao === 2) {
          return 'Cancelada pela instituição';
        } else if (solicitacao.statusSolicitacao === 3 || solicitacao.statusSolicitacao === 4 || solicitacao.statusSolicitacao === 5) {
          return 'Cancelada pelo coordenador';
        } else {
          return 'Aguardando liberação';
        }
      },
      tipo(tipo) {
        if (tipo === 0) {
          return 'Passagem';
        }
        if (tipo === 1) {
          return 'Diária';
        }

        return 'Adiantamento';
      },
      situacaoPrestacao(solicitacao) {
        if (solicitacao.dataHoraAceitoPrestConta) {
          return 'aceita';
        }
        if (solicitacao.motivoRejeicao) {
          return 'rejeitada';
        }
        if (solicitacao.dataHoraAtividade) {
          return 'enviada';
        }
        return 'pendente';
      },
      prazoVencido(solicitacao) {
        if (!solicitacao.dataLimitePrestacao) {
          return false;
        }
        if (this.situacaoPrestacao(solicitacao) === 'aceita') {
          return false;
        }

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        return new Date(solicitacao.dataLimitePrestacao) < hoje;
      },
      mostrarModalProtocolos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalProtocolos = true;
      },
      modalProtocolosFechado() {
        this.animated = false;
        this.modalProtocolos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista();
      },
    },
    created() {
      this.restaurarFiltros(this.$route.params.filtrosBag);
      this.aplicarFiltroDaNotificacao(this.$route.query.nivel);
      this.aplicarFiltroDoBeneficiario(this.$route.query.documento);

      this.lista();
    },
    mounted() {
      this.$root.tituloDaPagina = `Solicitação de Diária ${ this.configuracao.utilizarSolicitacaoAdiantamentoPassagemWeb ? ' - Passagem' : '' } ${ this.configuracao.utilizarSolicitacaoAdiantamentoWeb ? ' - Adiantamento' : '' } - Prestação de contas`;
      this.$root.botaoAcaoMostrar = false;

      this.$root.botaoRetrocederRota = '';
      this.$root.botaoAcaoTexto = '';
      this.$root.botaoRetrocederMostrar = false;

      if (this.coordenador) {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
          .change(function () {
            if (_this.filtros.idProjeto === this.value) return;

            _this.$set(_this.filtros, 'idProjeto', this.value);
            _this.lista();
          });

        this.listaDeProjetos();
      }
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .aceita {
    font-size: 1.50em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .enviada {
    font-size: 1.50em;
    color: #1c84c6;
    margin-right: 3px;
  }

  .rejeitada {
    font-size: 1.50em;
    color: #ed5565;
    margin-right: 3px;
  }

  .pendente {
    font-size: 1.50em;
    color: #f8c75a;
    margin-right: 3px;
  }

  .prazo-vencido {
    color: #ed5565;
    font-weight: bold;
  }

  .filtro-situacao {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0 8px 8px 0;
    padding: 7px 14px;
    border: 1px solid #d5d8dc;
    border-radius: 20px;
    background-color: #fff;
    font-weight: normal;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.15s, border-color 0.15s;
  }

  .filtro-situacao:hover {
    border-color: #1ab394;
  }

  .filtro-situacao.filtro-marcado {
    background-color: #e8f7f3;
    border-color: #1ab394;
    color: #1f6b52;
  }

  .filtro-situacao input {
    margin: 0;
    cursor: pointer;
  }

  .filtro-situacao .badge {
    font-weight: 600;
  }

  .linha-separador-secao > td {
    font-size: 0.9em;
    font-weight: 700;
    letter-spacing: 0.3px;
    padding: 12px 15px;
    border-top: 2px solid #ccc;
  }
  .linha-separador-secao.secao-rejeitada > td {
    background-color: #fdf2f0;
    color: #8a3a3a;
    border-top-color: #ed5565;
  }
  .linha-separador-secao.secao-pendente > td {
    background-color: #fcf8e3;
    color: #7a5a1b;
    border-top-color: #f8c75a;
  }
  .linha-separador-secao.secao-pendente-leve > td {
    background-color: #fdfbf2;
    color: #7a6a3b;
    border-top-color: #f3dfa2;
  }
  .linha-separador-secao.secao-enviada > td {
    background-color: #eef5fb;
    color: #245a86;
    border-top-color: #1c84c6;
  }
  .linha-separador-secao.secao-aceita > td {
    background-color: #eef8f4;
    color: #1f6b52;
    border-top-color: #1d9d74;
  }
  .secao-quantidade {
    font-weight: normal;
    letter-spacing: 0;
    margin-left: 6px;
    opacity: 0.8;
  }

  .painel-resumo {
    padding: 16px 20px;
    border-radius: 4px;
    margin-bottom: 15px;
    border-left: 5px solid;
    font-size: 1.05em;
  }
  .painel-atencao {
    background-color: #fdecea;
    border-left-color: #d9534f;
    color: #6b1f1c;
  }
  .painel-pendente {
    background-color: #fcf8e3;
    border-left-color: #f0ad4e;
    color: #7a5a1b;
  }
  .painel-em-dia {
    background-color: #dff0d8;
    border-left-color: #5cb85c;
    color: #2b542c;
  }
  .filtro-beneficiario {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .painel-detalhe {
    font-size: 0.9em;
    opacity: 0.85;
    margin-top: 4px;
    margin-left: 22px;
  }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-protocolos :mostrar="modalProtocolos"
                      :numeroProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.numeroProtocolo : ''"
                      @fechado="modalProtocolosFechado">
    </modal-protocolos>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoReembolso : ''"
                    tipo="SolReembolso"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row" v-if="!carregando && mostrarPainelResumo">
      <div class="col-lg-12">
        <div :class="['painel-resumo', quantidadeGrave > 0 ? 'painel-atencao' : (quantidadeParaPrestar > 0 ? 'painel-pendente' : 'painel-em-dia')]">
          <template v-if="quantidadeGrave > 0">
            <div>
              <i class="fa fa-exclamation-triangle"></i>
              <template v-if="quantidadePorNivel.rejeitada > 0">
                <strong>{{ quantidadePorNivel.rejeitada }}</strong>
                {{ quantidadePorNivel.rejeitada === 1 ? 'prestação rejeitada' : 'prestações rejeitadas' }}
              </template>
              <template v-if="quantidadePorNivel.rejeitada > 0 && quantidadePorNivel.vencida > 0"> e </template>
              <template v-if="quantidadePorNivel.vencida > 0">
                <strong>{{ quantidadePorNivel.vencida }}</strong>
                {{ quantidadePorNivel.vencida === 1 ? 'solicitação com prazo vencido' : 'solicitações com prazo vencido' }}
              </template>
            </div>
            <div class="painel-detalhe" v-if="quantidadePorNivel.vencendo > 0">
              e mais {{ quantidadePorNivel.vencendo }} com prazo terminando nos próximos {{ diasAlertaPrazo }} dias
            </div>
          </template>
          <template v-else-if="quantidadeParaPrestar > 0">
            <div>
              <i class="fa fa-clock-o"></i>
              <strong>{{ quantidadeParaPrestar }}</strong>
              {{ quantidadeParaPrestar === 1 ? 'solicitação aguardando prestação de contas' : 'solicitações aguardando prestação de contas' }}
            </div>
            <div class="painel-detalhe" v-if="quantidadePorNivel.vencendo > 0">
              {{ quantidadePorNivel.vencendo }} com prazo terminando nos próximos {{ diasAlertaPrazo }} dias
            </div>
          </template>
          <div v-else>
            <i class="fa fa-check-circle"></i>
            Nenhuma prestação de contas pendente.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="alert alert-info filtro-beneficiario" v-if="coordenador && filtros.documento">
              <span>
                <i class="fa fa-filter"></i>
                Mostrando apenas as solicitações do beneficiário <strong>{{ documentoFiltroFormatado }}</strong>.
              </span>
              <button type="button" class="btn btn-xs btn-default" @click="limparFiltroBeneficiario">
                <i class="fa fa-times"></i> Limpar filtro
              </button>
            </div>

            <div class="row" v-if="coordenador">
              <div class="col-sm-3">
                <div class="form-group">
                  <label class="control-label" for="situacao">Situação</label>
                  <select id="situacao"
                          class="form-control"
                          v-model="situacao"
                          @change="alterarSituacao">
                    <option v-for="item in situacoes" :key="item.valor" :value="item.valor">{{ item.label }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-5">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>
                  <select id="projeto" class="form-control">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="projeto in projetos" :key="projeto.idProjeto">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label class="control-label block">Período da solicitação</label>
                  <date-picker :value="filtros.periodo"
                               @input="alterarPeriodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label block">Mostrar</label>

                  <label :class="['filtro-situacao', { 'filtro-marcado': niveisMarcados.includes(secao.nivel) }]" v-for="secao in secoes" :key="secao.nivel">
                    <input type="checkbox"
                           :checked="niveisMarcados.includes(secao.nivel)"
                           @change="alternarNivel(secao.nivel)">
                    {{ secao.filtro }}
                    <span class="badge">{{ quantidadePorNivel[secao.nivel] }}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th v-if="usarMensageria">Mensagens</th>
                    <th class="text-center">Número</th>
                    <th>Data solicitação</th>
                    <th>Solicitante</th>
                    <th>Projeto</th>
                    <th v-if="!pessoaFisica">Beneficiário</th>

                    <th>Vencimento</th>
                    <th>Previsão</th>
                    <th>Efetivação</th>

                    <th>Valor (R$)</th>
                    <th>Tipo</th>
                    <th v-if="configuracao.criarProtocoloSolicitacao">Protocolo</th>
                    <th>Status</th>
                    <th>Prazo prestação</th>
                    <th>Prestação de contas</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, indice) in linhasComCabecalhos">
                  <tr v-if="item.tipo === 'cabecalho'"
                      :key="'h-' + item.secao.nivel"
                      :class="['linha-separador-secao', item.secao.classe]">
                    <td :colspan="totalColunas">
                      {{ item.secao.label }}
                      <span class="secao-quantidade">({{ item.quantidade }})</span>
                    </td>
                  </tr>
                  <tr v-else :key="item.solicitacao.idSolicitacaoReembolso + '-' + indice">
                    <td v-if="usarMensageria">
                      <div v-if="item.solicitacao.quantidadeNaoLida > 0">
                        <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{item.solicitacao.quantidadeNaoLida}}
                      </div>
                    </td>
                    <td class="text-center">{{ item.solicitacao.idSolicitacaoReembolso || '---' }}</td>
                    <td>{{ item.solicitacao.dataSolicitacao | formatarData }} - {{ item.solicitacao.dataSolicitacao | formatarHora }}</td>
                    <td>{{ item.solicitacao.solicitante || '---' }}</td>
                    <td>{{ item.solicitacao.nomeProjeto || '---' }}</td>
                    <td v-if="!pessoaFisica">{{ item.solicitacao.documentoTerceiro || '---' }} - {{ item.solicitacao.nomeTerceiro || '---' }}</td>


                    <td>{{ item.solicitacao.dataVencimento | formatarData('---') }}</td>
                    <td>{{ item.solicitacao.dataPrevisao | formatarData('---') }}</td>
                    <td>{{ item.solicitacao.dataLancamento | formatarData('---') }}</td>

                    <td>{{ item.solicitacao.valor | formatarNumero }}</td>
                    <td>{{ tipo(item.solicitacao.tipoReembolso) }}</td>
                    <td v-if="configuracao.criarProtocoloSolicitacao">
                      <a @click.prevent="mostrarModalProtocolos(item.solicitacao)" v-if="item.solicitacao.numeroProtocolo">{{ item.solicitacao.numeroProtocolo }} <i class="fa fa-external-link"></i></a>
                      <span v-if="!item.solicitacao.numeroProtocolo">---</span>
                    </td>
                    <td>{{ status(item.solicitacao) }}</td>
                    <td :class="{'prazo-vencido': prazoVencido(item.solicitacao)}">
                      {{ item.solicitacao.dataLimitePrestacao | formatarData('---') }}
                      <i class="fa fa-exclamation-triangle"
                         v-if="prazoVencido(item.solicitacao)"
                         v-tooltip="'Prazo de prestação de contas vencido. Entre em contato com a instituição.'"></i>
                      <div v-if="textoPrazo(item.solicitacao)"><small>{{ textoPrazo(item.solicitacao) }}</small></div>
                    </td>
                    <td>
                      <div v-if="situacaoPrestacao(item.solicitacao) === 'aceita'">
                        <i class="fa fa-check-circle-o aceita"></i> Aceita
                      </div>
                      <div v-if="situacaoPrestacao(item.solicitacao) === 'enviada'">
                        <i class="fa fa-clock-o enviada"></i> Aguardando conferência
                      </div>
                      <div v-if="situacaoPrestacao(item.solicitacao) === 'rejeitada'">
                        <i class="fa fa-times-circle rejeitada"></i> Rejeitada
                        <div><small class="text-muted">{{ item.solicitacao.motivoRejeicao }}</small></div>
                      </div>
                      <div v-if="situacaoPrestacao(item.solicitacao) === 'pendente'">
                        <i class="fa fa-exclamation-triangle pendente"></i> Sem prestação
                      </div>
                    </td>
                    <td>
                      <button type="button"
                              class="btn btn-secondary btn-xs"
                              v-tooltip="situacaoPrestacao(item.solicitacao) === 'pendente' || situacaoPrestacao(item.solicitacao) === 'rejeitada' ? 'Prestar contas' : 'Ver prestação de contas'"
                              @click="$router.push({ name: 'solicitacao-reembolso-pf-atividade.registrar', params: { idCript: item.solicitacao.idSolicitacao, filtrosBag } })">
                        <i class="fa"
                           :class="situacaoPrestacao(item.solicitacao) === 'pendente' || situacaoPrestacao(item.solicitacao) === 'rejeitada' ? 'fa-pencil' : 'fa-eye'"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              @click="mostrarModalMensagem(item.solicitacao)"
                              v-if="usarMensageria">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  </template>
                  <tr v-show="carregando">
                    <td :colspan="totalColunas">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                  <tr v-show="!totalLinhas && !carregando">
                    <td :colspan="totalColunas" class="text-center">Nenhuma solicitação encontrada.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-atividade/componentes/SolicitacaoReembolsoAtividadeLista.vue